// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"0312153c","73":"ef9c02ff","585":"ec2de149","626":"b5ce3ae1","656":"325d21fc","810":"6923659e","927":"9389dd83"}[chunkId] + ".chunk.js";
};